(function($) {
	'use strict';

	// function navigation
	$(document).on('click', '#burger', function() {
		$('body').toggleClass('navigate');
		$(this).toggleClass('is-active');
		$('.nav').toggleClass('shownav');
	});
	if(window.matchMedia("(max-width: 1080px)").matches) {
		$(document).on('click', '.mainmenu > .has-children > .show-sub', function() {
			$(this).toggleClass('active');
			$(this).siblings(".is-children").toggleClass('show');
			$(this).closest(".menu-item").toggleClass('open');
			return false;
		});

		// $(document).on('click', '.mainmenu .menu-item--lvl0 > .is-children .container-menu--lvl1 .menu-item--lvl1> .show-sub', function() {
		// 	$(this).siblings(".is-children").toggleClass('show');
		// 	return false;
		// });

	}

	// hide messages
	$(document).on('click', '.messages-close', function(){
		var $this = $(this);
		$this .closest('li').addClass('slideout');
		setTimeout(function() {
			$this .closest('li').slideUp();
		}, 1000)
	});

	// map contact
	// #mapid div exemple in page.html.twig
	if ($('#mapid').length > 0) {
		var lat = $('#mapid').attr('data-lat');
		var lng = $('#mapid').attr('data-lng');
		$('#filiale-container li:first-child .filiale_item').addClass('active');
		if($('#filiale-container li:first-child .filiale_item').attr('data-lat')) {
			lat = $('#filiale-container li:first-child .filiale_item').attr('data-lat');
		}
		if($('#filiale-container li:first-child .filiale_item').attr('data-lng')) {
			lng = $('#filiale-container li:first-child .filiale_item').attr('data-lng');
		}
		//var link = $('#mapid').attr('data-link');
		var mymap = L.map('mapid').setView([lat, lng], 10);

		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '© OpenStreetMap contributors',
			referrerPolicy: 'strict-origin-when-cross-origin'
		}).addTo(mymap);
		mymap.scrollWheelZoom.disable();

        var theMarkers = [];


		if($('.filiale_item').length>1) {
			var $count= 0;
			$('.filiale_item').each(function(){
                if($(this).attr('data-lat') && $(this).attr('data-lng')) {
                    theMarkers[$count] = [
                        $(this).attr('data-lat'), $(this).attr('data-lng'),$(this).find('.filiale_item--infos').html()
                    ];
                    $count++;
                } else {
                    theMarkers[$count] = [
                        '',''
                    ];
                    $count++;
                }
			});
		} else {
			theMarkers[0] = [
				lat,lng
			];
		}
        // multiples markers



		var marker = null,
			markerArray = [];
		for (var i = 0; i < theMarkers.length; i++) {

            // var pos = new L.LatLng(theMarkers[i][0],theMarkers[i][1]);
            // var icontext = iconclass?'':row.iconclass;
            var icon = L.divIcon({
                className: 'custom-div-icon',
                html: "<div class='marker-pin'></div>",
                iconSize: [24, 24],
                iconAnchor: [13,25]
            });
            var iconHide = L.divIcon({
                className: 'custom-div-icon',
                html: "<div class='marker-hide'></div>",
                iconSize: [24, 24],
                iconAnchor: [13,25]
            });

            var contentString = '<div class="markerInfo">\n\
										'+ theMarkers[i][2] + '\n\
                                        </div>';
            if(theMarkers[i][0] == 0 && theMarkers[i][1] == 0) {
                marker = new L.marker([theMarkers[i][0],theMarkers[i][1]],{icon: iconHide})
                    .addTo(mymap)
                    .bindPopup(contentString);
                markerArray.push(marker);
            } else {
                marker = new L.marker([theMarkers[i][0],theMarkers[i][1]],{icon: icon})
                    .addTo(mymap)
                    .bindPopup(contentString);
                markerArray.push(marker);
            }

        }

		// var group = new L.featureGroup(markerArray);
        // mymap.fitBounds(group.getBounds());
        // recenter map
        mymap.on('popupopen', function(e) {
            var px = mymap.project(e.popup._latlng);
            px.y -= e.popup._container.clientHeight/2
            mymap.panTo(mymap.unproject(px),{animate: true});
        });
		/****************** PAGE CONTACT LINK CLICK  **************/
		$(document).on('click', '.filiale_item', function(){
			var lat = $(this).attr('data-lat');
            var lng = $(this).attr('data-lng');

            //open current popup
            if(lat && lng) {
                $('.filiale_item').removeClass('active');
                $(this).addClass('active');
                mymap.setView([lat, lng], 10);
                for(var j = 0; j <markerArray.length; j++) {
                    if(lat == markerArray[j]._latlng.lat && lng == markerArray[j]._latlng.lng ) {
                        markerArray[j].openPopup();
                    }
                }
            } else {
                return false;
            }

		});

    }


	// js add message
	// function to print success message
	function addMessage(message, status) {
		var html = '<ul><li class="'+status+'">' + message + '<button class="messages-close"></button></li></ul>'
		if ( $('.messages').length == 0) {
			var mhtml = '<div class="messages">'+ html +'</div>';
			$('.main').append(mhtml);
		} else {
			$('.messages').append(html);
		}
	}
	//  usage : addMessage('message content', 'status');
	// available status are : is-error, is-status = is-success, is-info
	// example :
	// addMessage("ceci est un message d'erreur", 'is-error');
	// addMessage("ceci est un message de succès", 'is-success');
	// addMessage("ceci est un message réussi", 'is-status');
	// addMessage("ceci est un message d'info", 'is-info');

	/******************* WINDOWS SCROLL *******************/
	$(window).scroll(function(){
		if ($(window).scrollTop() >= 300) {
			$('header').addClass('effect-header');
		}
		else {
			$('header').removeClass('effect-header');
		}

	});
	// var headerHeight = $('.header').height();
	// $('.main').css('padding-top', headerHeight);

	// focus form
	$(document).on('focus', '.form-text, .form-email, .form-tel, .form-number, .form-search', function()  {
		$(this).closest('.form-item').addClass('focused');
	});
	$('.form-text, .form-email, .form-tel, .form-number, .form-search').each(function(){
		if( $(this).val() ) {
			$(this).closest('.form-item').addClass('focused');
		} else {
			$(this).closest('.form-item').removeClass('focused');
		}
	});
	$(document).on('blur', '.form-text, .form-email, .form-tel, .form-number, .form-search', function() {
		if( $(this).val() ) {
			$(this).closest('.form-item').addClass('focused');
		} else {
			$(this).closest('.form-item').removeClass('focused');
		}
	});

	if ($('.homepage_header--slider .slide').length > 1) {
		$('.homepage_header--slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 2500,
			speed: 1000,
		});
	}
	// SLIDER HOMEPAGE MARKET LV2
	if ($('.homepage_market--slider>div>div .views-row').length > 1) {
		$('.homepage_market--slider>div>div').slick({
			centerMode: true,
			variableWidth: true,
			slide: '.views-row',
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots: true,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 1000,
		});
	}

	// SLIDER HISTORY
	if ($('.our_history--slider>div>div .views-row').length > 1) {
		$('.our_history--slider>div>div').slick({
			slide: '.views-row',
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			dots:true,
    		appendDots:$(".our_history--navigation"),
			arrows: true,

			responsive: [
				{
					breakpoint: 780,
					settings: {
						dots: false,
					}
				}
		  	]
		});
	}

	// DATES HISTORY
	var dates = [];
	$(".our_history--slider .views-row:not(.slick-cloned) .history--date").each(function() {
		dates.push($(this).text());
	});

	$(".our_history--navigation button").each(function(i) {
		$(this).text(dates[i]);
	});



	// REVEAL
	var revealerpoint = 150;

	function scrollReveal() {
		var scrollTop = $(window).scrollTop();
		var height = $(window).height();
		var visibleTop = scrollTop + height;
		$('.reveal').each(function() {
			var $this = $(this);
			if ($this.hasClass('reveal_visible')) { return; }
			var top = $this.offset().top;

			if (top < (visibleTop - revealerpoint)) {
				$this.addClass('reveal_visible');
			}
		});
	}
	scrollReveal();

	$(window).scroll(function(){
		scrollReveal();
	});

	/**************** FIXED CONTACT PUSH  ***************/
	if($('.sidebar').length > 0) {

	// 	if(window.matchMedia("(min-width: 780px)").matches) {
	// 		$('#sidebar').stickySidebar({
	// 			containerSelector: '.page_content',
	// 			innerWrapperSelector: '.sidebar__inner'
	// 		});

    $(window).scroll(function(){
      if ($(window).scrollTop() >= 500) {
        $('.sidebar').addClass('show')
      } else {
        $('.sidebar').removeClass('show')
      }
    });
	// 	}

	}

	/**************** UPLOAD BTN  ***************/
	$( '.form-file' ).each( function()
	{
		var $input	 = $( this ),
			$label	 = $input.closest( 'label' ),
			labelVal = $label.html();

		$input.on( 'change', function( e )
		{
			var fileName = '';

			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else if( e.target.value )
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				$label.find( 'span' ).html( fileName );
			else
				$label.html( labelVal );
		});

		// Firefox bug fix
		$input
		.on( 'focus', function(){ $input.addClass( 'has-focus' ); })
		.on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
	});

	$(document).on('click', '#apply_btn', function() {
		$(this).closest('.container').siblings('.job_detail--form').slideToggle();
	});



	// lang switcher
	$(document).on('click', '.switcher--toggler:not(.slided)', function(e){
		// if (e.handled !== true) {
			$(this)
				.addClass('slided')
				.next('ul').slideDown();
		// 	e.handled = true;
		// }
		return false;
	});
	$(document).on('click', '.switcher--toggler.slided', function(e){
		// if (e.handled !== true) {
			$(this)
				.removeClass('slided')
				.next('ul').slideUp();
		// 	e.handled = true;
		// }
		return false;
	});

	// init effect appear
	AOS.init({
		disable: 'mobile',
		once: true,
	});



	/**************** UPLOAD BTN  ***************/
	$( '.form-file' ).each( function()
	{
		var $input	 = $( this ),
			$label	 = $input.closest( 'label' ),
			labelVal = $label.html();

		$input.on( 'change', function( e )
		{
			var fileName = '';

			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else if( e.target.value )
				fileName = e.target.value.split( '\\' ).pop();

			if( fileName )
				$label.find( 'span' ).html( fileName );
			else
				$label.html( labelVal );
		});

		// Firefox bug fix
		$input
		.on( 'focus', function(){ $input.addClass( 'has-focus' ); })
		.on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
	});

	/**************** FORM SELECT BTN  ***************/
  $('form .form-select').select2();


  // virtual-trade
  $('.virtual-trade_actions').on('click', '> a:not([href])', function(e) {
    var type = $(e.currentTarget).data('type')
    var url = $(e.currentTarget).data('url')
    var $content = $('.virtual-trade_popup_content')
    switch(type) {
      case 'image':
        $content.html('<img src="'+url+'">')
        break;
      case 'video':
        $content.html('<iframe src="'+url+'" style="width: 100%; height: 100%;" allowfullscreen="allowfullscreen" frameborder="0" allow="autoplay; fullscreen"></iframe>')
        break;
    }
    $('.virtual-trade').addClass('open')
  })
  $('.virtual-trade_popup_close').on('click', function(e) {
    e.stopPropagation()
    $('.virtual-trade').removeClass('open')
    setTimeout(function() {
      $('.virtual-trade_popup_content').html('')
    }, 200)
  })
  // /virtual-trade

  // This block only exists on the homepage.
  var homepageBottomBtn = document.querySelector('.homepage_bottom .btn');
  if (homepageBottomBtn) {
    homepageBottomBtn.addEventListener('click', function(e) {
      var description = document.querySelector('.homepage_bottom--description');
      description.classList.toggle('expanded');
      e.target.remove();
    })
  }

  // The Lila job offers iframe posts its content height so it can be resized.
  var lilaIframe = document.getElementById('lila_iframe');
  if (lilaIframe) {
    window.addEventListener('message', function(e) {
      var height = parseInt(e.data, 10);
      if (e.origin === 'https://applies.lila.fr' && height > 0) {
        lilaIframe.style.height = height + 'px';
      }
    });
  }

})(jQuery);
